// Angular imports
import { Component, OnInit, ChangeDetectionStrategy, ElementRef } from '@angular/core';
import { PercentPipe } from '@angular/common';

// Cell base class
import { CellComponent } from '../cell.component';

// Import types

// Types
export type LineTag = {
    icon: string;
    color: string;
    text?: string;
};

@Component({
    selector: 'tags-cell',
    templateUrl: './tags-cell.component.html',
    styleUrls: ['./tags-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [PercentPipe],
    standalone: false
})
export class TagsCellComponent extends CellComponent<LineTag[]> implements OnInit {
    constructor(
        hostElementRef: ElementRef,
        percentPipe: PercentPipe,
    ) {
        super(hostElementRef, percentPipe);
    }

    public focus(shallow: boolean = false): void {
        if (!shallow)
            this.onFocus.emit();
    }

    public blur(): void {
        // Cannot blur, do nothing
    }

    public select(setOrigin: boolean = false): void {
        // console.log('tags-cell | select');

        // If already selected, return
        if (this.isSelected) return;

        // console.log('tags-cell | select change emit');

        // Emit selection changed event
        // this.store.dispatch(CalculationActions.updateSelection({
        //     selection: {
        //         origin: setOrigin ? this.selection.origin ?? this.selection.current : undefined,
        //         current: { row: this.rowIndex, column: this.column.index }
        //     }
        // }));

        this.selectionChange.emit({
            origin: setOrigin ? this.selection.origin ?? this.selection.current : undefined,
            current: { row: this.rowIndex, column: this.column.index } 
        });
    }

    public selectContent(): void {
        // Cannot select content, do nothing
    }

    /* --- Event handlers --- */
}
